import React from "react";
import { content } from "../../data/careers";
import { downloadReport } from "./reportPdf";
import { IconDownload, IconArrowLeft } from "./icons";

const SuccessScreen = ({ refid, formData, rectype }) => {
  const s = content.success;
  return (
    <div className="crs-card">
      <div className="crs-success__top">
        <div className="crs-success__ring">
          <svg viewBox="0 0 80 80" width="80" height="80">
            <circle className="crs-su-ring-bg" cx="40" cy="40" r="34" />
            <circle className="crs-su-ring" cx="40" cy="40" r="34" />
            <polyline className="crs-su-tick" points="24,41 35,53 56,28" />
          </svg>
        </div>
        <h2 className="crs-success__title">{s.title}</h2>
        <p className="crs-success__sub">{s.subtitle}</p>
      </div>
      <div className="crs-success__divider" />
      <div className="crs-success__body">
        <div className="crs-success__ref">
          <p className="crs-success__ref-label">{s.refLabel}</p>
          <p className="crs-success__ref-id">{refid}</p>
        </div>
        <p className="crs-success__note">{s.note}</p>
        <div className="crs-success__actions">
          <button type="button" className="btn-ed btn-ed--primary" onClick={() => downloadReport(formData, rectype)}>
            <IconDownload style={{ width: 16, height: 16, marginRight: 9 }} />
            {s.downloadLabel}
          </button>
          <a href={s.homeLink} className="btn-ed btn-ed--ghost crs-success__home">
            <IconArrowLeft style={{ width: 15, height: 15 }} />
            {s.homeLabel}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
